import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Avatar from '../../nucleus/avatar/avatar';
import subroutes from './profile-subroutes';
import PageHeaderDefault from '../../nucleus/header/page-header-default';

class ProfilePage extends React.Component {
  componentDidMount() {
    document.title = 'Deal IQ | Profile';
  }

  renderUserName = () => {
    const {
      first_name,
      last_name,
      avatar,
    } = this.props.userData || {};
    return (
      <div>
        <Avatar
          enableHover
          firstName={first_name}
          hoverAlign="left"
          image={avatar}
          lastName={last_name}
          sizing="lg"
        />&nbsp;
        {
          first_name && last_name
            ? `${first_name} ${last_name}`
            : ''
        }
      </div>);
  };

  renderTabs = (renderProxy, proxy, auth_groups) => [
    {
      link: '/profile/overview',
      text: 'Profile',
    },
    {
      link: '/profile/teams',
      text: 'Teams',
    },
    {
      link: '/profile/labs',
      text: 'Labs',
      disabled: !isEmpty(proxy),
    },
    {
      link: '/profile/manage-proxy',
      hidden: !renderProxy,
      text: 'Grant Proxy Access',
      disabled: !isEmpty(proxy),
    },
    {
      link: '/profile/switch-proxy',
      hidden: !renderProxy,
      text: 'Proxy Access',
    },
    {
      link: '/profile/attachment-lookup',
      text: 'Attachment Lookup',
      hidden: !(auth_groups && auth_groups.indexOf('can_access_attachment_lookup_tools') > -1),
    },
  ];

  render() {
    const {
      userData,
      userOptions,
      loadUserData,
      updateUserData,
      proxy,
    } = this.props;

    return (
      <React.Fragment>
        <PageHeaderDefault
          title={this.renderUserName()}
          tabs={this.renderTabs(true, proxy, userData && userData.auth_groups)}
          pageUrl={this.props.location.pathname}
        />
        {subroutes.filter((route) => !route.requiresGroup || (userData && userData.auth_groups && userData.auth_groups.indexOf(route.requiresGroup) > -1)).map((route) => {
          const RouteComponent = route.component;
          return (<Route
            path={route.path}
            exact={route.exact}
            key={route.path}
            render={() => (<RouteComponent
              userOptions={userOptions}
              user={userData}
              loadUserData={loadUserData}
              updateUserData={updateUserData}
              avatar={userData.avatar}
            />)}
          />);
        })}
        { this.props.location.pathname === '/profile' &&
          <Redirect to="/profile/overview" />
        }
      </React.Fragment>
    );
  }
}

ProfilePage.propTypes = {
  userData: PropTypes.shape({
    auth_groups: PropTypes.arrayOf(PropTypes.string),
    avatar: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  loadUserData: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
  userOptions: PropTypes.shape({ feature_flags: PropTypes.shape({ react_vouchers_flag: PropTypes.bool }) }),
  proxy: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
};

ProfilePage.defaultProps = {
  userOptions: { feature_flags: { react_vouchers_flag: false } },
  userData: {
    auth_groups: [],
  },
  location: {
    pathname: '',
  },
};

export default ProfilePage;
